import { ApolloError } from "apollo-client";
import { useMutation } from "@apollo/react-hooks";

import createAreaCoverageMutation from "../graphql/createAreaCoverage.graphql";

const useMutationCreateAreaCoverage = ({
  onCompleted,
  onError,
}: {
  onCompleted: () => void;
  onError?: (err: ApolloError) => void;
}) =>
  useMutation(createAreaCoverageMutation, {
    onCompleted,
    onError: err => {
      if (err.graphQLErrors.length) {
        if (onError) {
          onError(err);
        }
      }
    },
  });

export default useMutationCreateAreaCoverage;
